import { render, staticRenderFns } from "./EnergyFlower.vue?vue&type=template&id=60a09058&"
import script from "./EnergyFlower.vue?vue&type=script&lang=js&"
export * from "./EnergyFlower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports